'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProjectServiceCtrl
 * @description
 * # ProjectCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('Project', ['$http', '$q', 'domain', 'BaseService', 'toaster', function ($http, $q, domain, BaseService, toaster) {
    var BASE_PROJECT_URL = domain.name + '/api/v1/projects/';
    var INITIAL_ACTIVE_PROJECTS = 50;
    var searchCache = {};
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_PROJECT_URL,
      baseModelName: 'project'
    });

    baseService.aasm_transition = function(params) {
      return $http.post(BASE_PROJECT_URL + params.project.id + '/aasm_transition', params);
    };

    baseService.project_stages = function(params) {
      return $http.get(BASE_PROJECT_URL + params.id + '/project_stages', params);
    };

    baseService.comment = function(params) {
      return $http.put(BASE_PROJECT_URL + params.project.id , params);
    };

    baseService.extendProject = function(params) {
      return $http.post(BASE_PROJECT_URL + params.id + '/extend_project', params);
    };

    baseService.completelyInvoiced = function(params) {
      return $http.post(BASE_PROJECT_URL + params.id + '/completely_invoiced', params);
    };

    baseService.partiallyInvoiced = function(params) {
      return $http.post(BASE_PROJECT_URL + params.id + '/partially_invoiced', params);
    };

    baseService.notify_user = function(params) {
      return $http.post(BASE_PROJECT_URL + params.id + '/notify_user', params);
    };

    baseService.downloadProjects = function(params) {
      return $http.get(domain.name + '/api/v1/projects.csv', params );
    };

    baseService.getNextProjectCode = () => {
      return $http.get(domain.name + '/api/v1/get_next_project_code');
    };

    baseService.searchWithCache = function(searchQuery, onlyActiveProjects) {
      var term = (searchQuery || '').trim();

      if (!term && !onlyActiveProjects) {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      var cacheKey = (onlyActiveProjects ? 'active:' : 'all:') +
        term.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[&%\-\/_ ]/g, "");

      if (searchCache[cacheKey]) {
        var deferred = $q.defer();
        deferred.resolve(searchCache[cacheKey]);
        return deferred.promise;
      }

      var projectParams = { 'params': {} };

      if (term) {
        projectParams.params.search = term;
      }

      if (onlyActiveProjects) {
        projectParams.params.as_options = true;

        if (!term) {
          projectParams.params.by_active_state = true;
          projectParams.params.per_page = INITIAL_ACTIVE_PROJECTS;
        }
      }

      var deferred = $q.defer();
      baseService.index(projectParams).then(function(response) {
        searchCache[cacheKey] = response.data.projects;
        deferred.resolve(response.data.projects);
      }).catch(function(error) {
        baseService.error(error);
        deferred.reject(error);
      });
      return deferred.promise;
    };

    baseService.sanitizeParams = function(project) {
      delete project.audited;
      delete project.client;
      delete project.product_catalog;
      delete project.project_type_catalog;
      delete project.rape;
      delete project.project_code;
      delete project.permitted_events;
      delete project.project_type_catalog_list;
      delete project.children_project;
      delete project.invoices;
      delete project.invoice_folios;
      delete project.invoiceable;
      delete project.state;
      return project;
    };

    baseService.warningUpdate = function() {
      return toaster.pop('warning', 'Google Drive', 'Recuerda hacer los cambios necesarios en el drive.');
    };

    baseService.error = function(error) {
      if(error && error.status === 422) {
        if('name' in error.data.errors) {
          toaster.pop('error', 'Nombre', 'El nombre del proyecto ' + error.data.errors.name);
        }
        if('project_code' in error.data.errors) {
          // jscs:disable
          toaster.pop('error', 'Código de Proyecto', 'El código de proyecto ' + error.data.errors.project_code);
          // jscs:enable
        }
        if('audit_comment' in error.data.errors) {
          toaster.pop('error', 'Comentario', 'Favor de incluir un comentario');
        }
        if('drive_root_id' in error.data.errors) {
          toaster.pop('error', 'Ruta de Google', 'Favor de selecionar una ruta para el proyecto');
        }
        if('client_id' in error.data.errors) {
          toaster.pop('error', 'Cliente', 'Favor de selecionar un cliente para le proyecto');
        }
        if('project_type_catalog_id' in error.data.errors) {
          toaster.pop('error', 'Tipo de Proyecto', 'Favor de selecionar una tipo de proyecto');
        }
        if('product_catalog_id' in error.data.errors) {
          toaster.pop('error', 'Producto', 'Favor de selecionar un producto');
        }
        if('rape_id' in error.data.errors) {
          toaster.pop('error', 'Rape', 'Favor de selecionar un empleado rape');
        }
        if('invalid_transition' in error.data.errors) {
          toaster.pop('error', 'Cambio de estado', error.data.errors.invalid_transition[0]);
        }
        if('estimate_hours_needed' in error.data.errors) {
          toaster.pop('error', 'Horas estimadas', error.data.errors.estimate_hours_needed[0]);
        }
        if('project_date' in error.data.errors) {
          toaster.pop('error', 'Fecha', error.data.errors.project_date[0]);
        }
        if('eta' in error.data.errors) {
          toaster.pop('error', 'Fecha de Entrega', error.data.errors.eta[0]);
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
